import { useMemo } from 'react';

import { FileStatus, FileType, ProjectFile } from 'services/file.service';
import { FinalCut, RenderStatus } from 'services/finalcut.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { setHoveredFile, setHoveredFc } from '../../_mediator/projects.slice';

import { Loader } from 'components/UI/loader/loader';
import styles from '../_sections.module.scss';

export const ThumbFile = ({ el }: { el: ProjectFile }) => {
  const posters = useAppSelector((state) => state.app__files.posters);
  const dispatch = useAppDispatch();

  const FilePrev = useMemo(() => {
    if (el.status === FileStatus.Error) return <span>Error</span>;
    if (posters[el.id]) return <img src={posters[el.id]!} crossOrigin="anonymous" />;
    return <span>{FileType[el.fileType]}</span>;
  }, [el, posters[el.id]]);

  return (
    <td
      className={styles.Table__thumbnails}
      onMouseEnter={() => dispatch(setHoveredFile(el.id))}
      onMouseLeave={() => dispatch(setHoveredFile(null))}
    >
      <div>{FilePrev}</div>
    </td>
  );
};

export const ThumbFc = ({ el }: { el: FinalCut }) => {
  const dispatch = useAppDispatch();

  const FilePrev = useMemo(() => {
    if (el.status === RenderStatus.error) return <span>Error</span>;
    if (el.thumbnailUrl) return <img src={el.thumbnailUrl} crossOrigin="anonymous" />;
    return (
      <span>
        <Loader className={styles.spinner} />
      </span>
    );
  }, [el]);

  return (
    <td
      className={styles.Table__thumbnails}
      onMouseEnter={() => dispatch(setHoveredFc(el.id))}
      onMouseLeave={() => dispatch(setHoveredFc(null))}
    >
      <div>{FilePrev}</div>
    </td>
  );
};
